import requestTypesApi from '../../api/request-types-api'

const state = {
  requestTypes: [],
}

const mutations = {
  setRequestTypes(state, val) {
    state.requestTypes = val
  },
  addRequestType(state, val) {
    state.requestTypes.push(val)
  },
  updateRequestType(state, val) {
    const idx = state.requestTypes.findIndex(rt => rt.id === val.id)
    if (idx !== -1) {
      state.requestTypes.splice(idx, 1, val)
    }
  },
  removeRequestType(state, id) {
    state.requestTypes = state.requestTypes.filter(rt => rt.id !== id)
  },
}

const actions = {
  async list({ commit }, client_id) {
    commit('app/loading', true, { root: true })
    await requestTypesApi.list(client_id).then(
      response => {
        commit('setRequestTypes', response.data)
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al obtener los tipos de solicitud.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
  async create({ commit }, data) {
    commit('app/loading', true, { root: true })
    return requestTypesApi.create(data).then(
      response => {
        commit('addRequestType', response.data)
        commit('notifications', { title: 'Tipo de solicitud creado con éxito.', variant: 'success' }, { root: true })
        commit('setShowNotifications', true, { root: true })
        commit('app/loading', false, { root: true })
        return response.data
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al crear el tipo de solicitud.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
        throw new Error()
      },
    )
  },
  async update({ commit }, { id, data }) {
    commit('app/loading', true, { root: true })
    return requestTypesApi.update(id, data).then(
      response => {
        commit('updateRequestType', response.data)
        commit('notifications', { title: 'Tipo de solicitud actualizado con éxito.', variant: 'success' }, { root: true })
        commit('setShowNotifications', true, { root: true })
        commit('app/loading', false, { root: true })
        return response.data
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al actualizar el tipo de solicitud.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
        throw new Error()
      },
    )
  },
  async delete({ commit }, id) {
    commit('app/loading', true, { root: true })
    await requestTypesApi.delete(id).then(
      () => {
        commit('removeRequestType', id)
        commit('notifications', { title: 'Tipo de solicitud eliminado con éxito.', variant: 'success' }, { root: true })
        commit('setShowNotifications', true, { root: true })
        commit('app/loading', false, { root: true })
      },
      () => {
        commit('app/loading', false, { root: true })
        commit('notifications', { title: 'Error al eliminar el tipo de solicitud.', variant: 'danger' }, { root: true })
        commit('setShowNotifications', true, { root: true })
      },
    )
  },
}

const getters = {
  getRequestTypes: state => state.requestTypes,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}